import React from "react";
import { imagePath } from "../../constants/imagePath";

/**
 * App logo from bundled asset (src/assets/images/yug_mantra_logo.png).
 * Use a PNG with transparency for correct display on any header background.
 */
const BrandLogo = ({
  className = "",
  alt = "Yug Mantra",
  objectPosition = "center",
  style,
   isScrolled = false,
  isHeaderHovered = false,
   isStaticPage = false,
  ...rest
}) => (
  <img
    // src={imagePath.appLogo}
     src={
         isStaticPage || isScrolled || isHeaderHovered
        ? imagePath.appLogo
        : imagePath.whiteLogo
    }
    alt={alt}
    className={className}
    style={{ objectPosition, ...style }}
    {...rest}
  />
);

export default BrandLogo;
